import React from 'react';
import AsyncSelect from 'react-select/async';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { GET_LAND_SUB_CLASSIFICATIONS } from '../../../constant';
import { getLandSubClassificationList } from '../../../action';

const selectList = ({ api }) => {
  return _.get(api, `${GET_LAND_SUB_CLASSIFICATIONS}.list`) || [];
};

const formatOptions = (data) => {
  return data.map((item) => {
    return {
      label: _.get(item, 'attributes.rptax_location_name'),
      value: _.get(item, 'id'),
      fullInfo: item,
      rptax_land_sub_classification_id: _.get(
        item,
        'attributes.land_sub_classification_id'
      ),
      land_sub_classification_code: _.get(
        item,
        'attributes.land_sub_classification_code'
      ),
      unit_value: _.get(item, 'attributes.unit_value'),
    };
  });
};
const SubClassification = ({
  name,
  onChange,
  value,
  readOnly,
  id,
  ordinanceRevisionId,
}) => {
  const dispatch = useDispatch();
  const list = useSelector(selectList);
  const options = [...formatOptions(list)];

  const findValue = options.find((item) => {
    if (!value) return '';
    return +_.get(item, 'value') === +value || '';
  });

  // useEffect(() => {
  //   if (value) dispatch(getLandSubClassificationList(id, { code: value, id }));
  // }, [value]);

  const handleChange = (data) => {
    onChange({
      target: {
        name,
        value: data.value,
        rptax_land_sub_classification_id: data.rptax_land_sub_classification_id,
        land_sub_classification_code: data.land_sub_classification_code,
        unit_value: data.unit_value,
      },
    });
  };

  const loadOptions = (inputValue, callback) => {
    dispatch(
      getLandSubClassificationList(
        id,
        { q: inputValue, id, ordinance_revision_id: ordinanceRevisionId },
        (response) => {
          callback(formatOptions(_.get(response, 'data')));
        }
      )
    );
  };

  const loadOptionsDebounce = _.debounce(loadOptions, 500);

  return readOnly === true ? (
    <span className="full-input text-uppercase">
      {_.get(findValue, 'label')}
    </span>
  ) : (
    <AsyncSelect
      placeholder="- Type to Search Sub Classification -"
      value={findValue}
      onChange={handleChange}
      defaultOptions={formatOptions(list)}
      loadOptions={loadOptionsDebounce}
      components={{
        IndicatorSeparator: () => null,
      }}
    />
  );
};

SubClassification.defaultProps = {
  name: undefined,
  readOnly: undefined,
};

SubClassification.propTypes = {
  readOnly: PropTypes.bool,
  onChange: PropTypes.instanceOf(Function).isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string,
  id: PropTypes.string.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

export default SubClassification;
